import React from 'react';

export const useForwardedRef = <T>(forwardedRef?: React.ForwardedRef<T>) => {
  const localRef = React.useRef<HTMLAnchorElement>(null);
  return (forwardedRef ?? localRef) as React.RefObject<T>;
};
